import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import NewsSiderContent from '../../../../components/newsSiderContent';
import { rel } from '../../../../../utils/rel';

class JpList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div>
                <ul className={styles.jp_list}>
                    {content.slice(0, 4).map((item, index) => (
                        <li key={index}>
                            <a href={item.url} target="_blank" rel={rel}>
                                <img src={item.thumbnail} />
                            </a>
                            <h5>
                                <a href={item.url} target="_blank" rel={rel}>
                                    {item.title}
                                </a>
                            </h5>
                        </li>
                    ))}
                </ul>
                <NewsSiderContent content={content.slice(4)} isVideo />
            </div>
        );
    }
}

export default errorBoundary(JpList);
